import * as React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
const useStyles = makeStyles(({
  breakpoints,
  typography
}) => ({
  parcelNumber: {
    fontSize: typography.pxToRem(15),
    fontWeight: 300,
    lineHeight: 1.5,
    letterSpacing: 0.44,
    marginBottom: typography.pxToRem(30),
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(13),
      fontWeight: 400,
      lineHeight: 1.6
    }
  }
}));

const TitleWithNumber = ({
  title
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(Typography, {
    className: styles.parcelNumber
  }, title);
};

export default TitleWithNumber;